import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    padding: '30px 20px',
    width: '300px',
  },
  profile: {
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      width: '76px',
      height: '76px',
      border: '2px solid #eee',
      borderRadius: '38px',
    },
  },
  infos: {
    marginLeft: '15px',

    '& h1': {
      margin: 0,
      padding: 0,
      fontSize: '1rem',
      fontWeight: 400,
      fontFamily: 'Montserrat',
    },
  },
  submit: {
    width: '100%',
    cursor: 'pointer',
    marginTop: '30px',
    background: '#ff0000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 0',
    color: '#ffff',
    borderRadius: '5px',
    border: 'none',
    fontFamily: 'Montserrat',
    textTransform: 'uppercase',
  },
}));

export default useStyles;
